module.exports = __webpack_public_path__ + "img/dropdown.02e2d18d.svg";